var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"filterButton d-flex justify-space-between",attrs:{"tile":"","outlined":""}},[_c('span',{staticClass:"buttonText"},[_vm._v("FILTRO")]),_c('Icon',{attrs:{"size":"24","icon":"mdi-filter-outline","color":"#0012A6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }